import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Filter from "../components/datatable/Filter";
import Button from "../components/Button";

const FILTER_OPTIONS = {
    all: {
        name:   'All',
        value:  'all',
    },
    draft: {
        name:   'Draft',
        value:  'draft',
    },
    ready_to_send: {
        name:   'Ready To Send',
        value:  'ready_to_send',
    },
    sent: {
        name:   'Sent',
        value:  'sent',
    },
    converted: {
        name:   'Converted',
        value:  'converted',
    },
    discarded: {
        name:   'Discarded',
        value:  'discarded',
    },
    archived: {
        name:   'Archived',
        value:  'archived',
    },
}

const OverviewQuoteDataTable = (props) => {
    const dataTableRef          = useRef(null);
    const [search, setSearch]   = useState("");
    const [statusFilter, setFilter]   = useState(FILTER_OPTIONS.all.value);
    const [jobTypeFilter, setJobTypeFilter] = useState(null);
    const [userFilter, setUserFilter]       = useState(null);

    const renderRowButton = (quote) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!quote.can && quote.can.view === true && quote.deleted_at === "-" && (
                        <a className="text-primary cursor-pointer" href={route('job.quote.index', {job: quote.job_id}).toString()}>
                            View
                        </a>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card classes={"border-0"} noPadding={true}>
                <div className="row">
                    <div className='col-12 col-xl-3 mb-3'>
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                    <Filter
                        label={"Status:"}
                        value={statusFilter}
                        options={Object.values(FILTER_OPTIONS)}
                        name={"filter_status"}
                        onChange={(value) => setFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"Job Type:"}
                        value={jobTypeFilter}
                        options={props.jobTypes}
                        name={"filter_job_type"}
                        onChange={(value) => setJobTypeFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"User:"}
                        value={userFilter}
                        options={props.users}
                        name={"filter_user"}
                        onChange={(value) => setUserFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <div className='col-1'></div>
                    {can('create', 'job') && (
                        <div className="col-2 col-xs-4 float-right mb-3">
                            <Button
                                href={route('job.create', {origin: "overview-quote"}).toString()}
                                label={"Create Job"}
                                icon={"far fa-plus-circle"}
                                classes={"btn btn-eh-lilac px-3 justify-content-center"}
                            />
                        </div>
                    )}
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.overview.quote.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="quotes" />}
                                fieldsToExclude={statusFilter === FILTER_OPTIONS.archived.value ? [
                                    'created_at',
                                    'can',
                                ] : [
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    'id',
                                    'name',
                                    'job_id',
                                    'job_name',
                                    'job_type',
                                    'customer_name',
                                    'user_name',
                                    'products_sum_price',
                                    'created_at',
                                    'status',
                                ]}
                                fieldMap={{
                                    id:                 "Quote Ref",
                                    name:               "Quote Name",
                                    job_id:             "Job Ref",
                                    job_name:           "Job Name",
                                    job_type:           "Type",
                                    customer_name:      "Customer",
                                    user_name:          "User",
                                    products_sum_price: "Quoted Value",
                                    created_at:         "Quote Created",
                                    deleted_at:         "Date Archived",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'id'}
                                defaultOrderByDirection={'desc'}
                                params={{
                                    searchTerm:   search,
                                    statusFilter: statusFilter,
                                    jobTypeFilter: jobTypeFilter,
                                    userFilter:    userFilter,
                                }}
                                buttons={(row) => renderRowButton(row)}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default OverviewQuoteDataTable;

const target = document.getElementById('overview-quote-datatable');
if (target) {
    ReactDOM.render(
        <OverviewQuoteDataTable
            jobTypes={JSON.parse(target.dataset.jobTypes)}
            users={JSON.parse(target.dataset.users)}
        />,
        target
    );
}
